module.exports = __webpack_public_path__ + "static/media/topup-plan-active.4e025425.svg";